(function () {

  function setupCarousel(root) {
    const track    = root.querySelector('.ec-track');
    const viewport = root.querySelector('.ec-viewport') || track?.parentElement;
    const slides   = () => Array.from(track.children);
    const btnPrev  = root.querySelector('[data-ec-action="prev"]');
    const btnNext  = root.querySelector('[data-ec-action="next"]');

    const effect   = root.dataset.effect   || 'slide';
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval || '5000', 10);
    const loop     = root.dataset.loop !== 'false';

    root.style.position     = 'relative';
    viewport.style.overflow = 'hidden';
    viewport.style.width    = '100%';

    let index     = 0;
    let animating = false;
    let goTo;   // sera défini selon l'effet, utilisé par autoplay

    // ─── FADE ─────────────────────────────────────────────────────────────────
    if (effect === 'fade') {

      function setFadeViewportHeight() {
        slides().forEach((s) => { s.style.visibility = 'hidden'; s.style.opacity = '1'; });
        const maxH = Math.max(...slides().map((s) => s.offsetHeight));
        slides().forEach((s) => { s.style.visibility = ''; s.style.opacity = ''; });
        viewport.style.height = maxH + 'px';
        track.style.height    = maxH + 'px';
      }

      function updateActive() {
        slides().forEach((s, i) => {
          const active = i === index;
          s.classList.toggle('ec-active', active);
          s.style.zIndex        = active ? '1' : '0';
          s.style.pointerEvents = active ? '' : 'none';
        });
      }

      goTo = function (i) {
        const len = slides().length;
        index = loop ? (i + len) % len : Math.max(0, Math.min(i, len - 1));
        updateActive();
      };

      new ResizeObserver(() => { setFadeViewportHeight(); goTo(index); }).observe(root);
      setFadeViewportHeight();
      updateActive();

    // ─── SLIDE : toujours vers la gauche ──────────────────────────────────────
    } else {

      track.style.position = 'relative';
      track.style.width    = '100%';

      function syncHeight() {
        const active = slides()[index];
        if (active) track.style.height = active.offsetHeight + 'px';
      }

      // Place tous les slides en absolute, hors champ à droite sauf le premier
      function initSlides() {
        slides().forEach((s, i) => {
          s.style.position      = 'absolute';
          s.style.top           = '0';
          s.style.left          = '0';
          s.style.width         = '100%';
          s.style.boxSizing     = 'border-box';
          s.style.transform     = i === 0 ? 'translateX(0%)' : 'translateX(100%)';
          s.style.transition    = 'none';
          s.style.opacity       = '1';
          s.style.pointerEvents = i === 0 ? '' : 'none';
          s.classList.toggle('ec-active', i === 0);
        });
        syncHeight();
      }

      goTo = function (nextIndex) {
        if (animating) return;
        const len    = slides().length;
        const target = loop
          ? (nextIndex + len) % len
          : Math.max(0, Math.min(nextIndex, len - 1));

        if (target === index) return;
        animating = true;

        const current = slides()[index];
        const next    = slides()[target];

        // Positionne le prochain hors champ à droite, sans transition
        next.style.transition    = 'none';
        next.style.transform     = 'translateX(100%)';
        next.style.opacity       = '1';
        next.style.pointerEvents = 'none';
        next.getBoundingClientRect(); // force repaint

        const dur    = '0.45s';
        const easing = 'cubic-bezier(0.4, 0, 0.2, 1)';
        current.style.transition = `transform ${dur} ${easing}`;
        next.style.transition    = `transform ${dur} ${easing}`;

        // Current → gauche, next → centre
        current.style.transform = 'translateX(-100%)';
        next.style.transform    = 'translateX(0%)';

        next.classList.add('ec-active');
        next.style.pointerEvents = '';

        next.addEventListener('transitionend', function onEnd() {
          current.style.transition    = 'none';
          current.style.transform     = 'translateX(100%)'; // remet à droite hors champ
          current.style.pointerEvents = 'none';
          current.classList.remove('ec-active');
          index     = target;
          animating = false;
          syncHeight();
        }, { once: true });
      };

      new ResizeObserver(() => syncHeight()).observe(root);
      initSlides();
    }

    // ─── Boutons & clavier ────────────────────────────────────────────────────
    btnNext?.addEventListener('click', () => goTo(index + 1));
    btnPrev?.addEventListener('click', () => goTo(index - 1));

    (viewport || root).addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(index - 1); }
    });

    // ─── Swipe touch ──────────────────────────────────────────────────────────
    let touchStartX = null, touchStartY = null;
    (viewport || root).addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    (viewport || root).addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        dx < 0 ? goTo(index + 1) : goTo(index - 1);
      }
      touchStartX = null; touchStartY = null;
    }, { passive: true });

    // ─── Autoplay ─────────────────────────────────────────────────────────────
    let timer = null;
    function startAutoplay() { if (autoplay) timer = setInterval(() => goTo(index + 1), interval); }
    function stopAutoplay()  { clearInterval(timer); timer = null; }

    if (autoplay) {
      startAutoplay();
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      (viewport || root).addEventListener('focusin',  stopAutoplay);
      (viewport || root).addEventListener('focusout', startAutoplay);
    }
  }

  function init() {
    document
      .querySelectorAll('.wp-block-brblocks-elements-carousel, .ec-wrapper')
      .forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();